(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[883],{

/***/ 234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1131);
/* harmony import */ var global_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(561);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4337);
/* harmony import */ var _UI_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8356);
/* harmony import */ var _UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5653);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5260);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







function Pagination(param) {
    var pages = param.pages;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var ref = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_5__/* .useAtom */ .KO)(global_store__WEBPACK_IMPORTED_MODULE_1__/* .currentPageAtom */ .ef), 2), currentPage = ref[0], setCurrentPage = ref[1];
    var pageNumbers = getPages(currentPage, pages);
    var paginate = function(page) {
        var getOffset = function getOffset(el) {
            var rect = el.getBoundingClientRect();
            return {
                left: rect.left + window.scrollX,
                top: rect.top + window.scrollY
            };
        };
        setCurrentPage(page);
        //window.scrollTo({ top: 0, behavior: 'smooth' });
        var position = getOffset(document.getElementById("product_container"));
        var scrollPos = {
            x: 0,
            y: position.top
        };
        window.scrollTo({
            top: scrollPos.y,
            behavior: "smooth"
        });
        sessionStorage.setItem("pagination_change", JSON.stringify(scrollPos));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_3__/* .FlexBox */ .h, {
        align: "center",
        alignSelf: "center",
        mt: 42,
        children: [
            pages > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavigationButton, {
                text: t("previous"),
                inactive: currentPage === 1,
                onClick: function() {
                    return paginate(currentPage - 1);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_3__/* .FlexBox */ .h, {
                spaceX: 4,
                children: pageNumbers.map(function(page) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xuv, {
                        as: "span",
                        role: "button",
                        onClick: function() {
                            return page !== "..." && paginate(page);
                        },
                        "aria-label": "Paginate to page ".concat(page),
                        p: "4px 12px",
                        border: currentPage === page ? "1px solid #45AAC4" : "none",
                        borderRadius: 3,
                        color: "#343434",
                        cursor: currentPage === page || page === "..." ? "auto" : "pointer",
                        children: page
                    }, page);
                })
            }),
            pages > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavigationButton, {
                text: t("next"),
                inactive: currentPage === pageNumbers.slice(-1)[0],
                onClick: function() {
                    return paginate(currentPage + 1);
                }
            })
        ]
    });
};
var NavigationButton = function(param) {
    var onClick = param.onClick, text = param.text, inactive = param.inactive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_UI_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        as: "span",
        role: "button",
        "aria-label": "Navigate to ".concat(text),
        onClick: onClick,
        pointerEvents: inactive ? "none" : "auto",
        fontSize: {
            _: "0.875rem",
            desktop: "1rem"
        },
        color: inactive ? "#BABABA" : "#343434",
        hoverOpacity: inactive ? 1 : 0.75,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xuv, {
                as: "span",
                mr: 6,
                children: text === "Eelmine" || text === "Previous" && "<"
            }),
            text,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xuv, {
                as: "span",
                ml: 6,
                children: text === "J\xe4rgmine" || text === "Next" && ">"
            })
        ]
    });
};
var getPages = function(currentPage, pageCount) {
    var delta = 2;
    var range = [];
    for(var i = Math.max(2, currentPage - delta); i <= Math.min(pageCount - 1, currentPage + delta); i += 1){
        range.push(i);
    }
    if (currentPage - delta > 2) {
        range.unshift("...");
    }
    if (currentPage + delta < pageCount - 1) {
        range.push("...");
    }
    range.unshift(1);
    if (pageCount !== 1) range.push(pageCount);
    return range;
};


/***/ }),

/***/ 681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_products_useProductCardPrice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9926);
/* harmony import */ var utils_getProductImage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7883);
/* harmony import */ var _DiscountPercentBadge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4522);
/* harmony import */ var _UI_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9696);
/* harmony import */ var _UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1028);
/* harmony import */ var _UI_Button_AddToCart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5618);
/* harmony import */ var _UI_Ratings_StarRating__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9565);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4567);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










/**
 * ProductCard
 *
 * Generic product card component
 *
 * @prop {object} product - object of a single product
 * @prop {object} imageSize - object of image width and height {width, height}
 * @prop {object} badges - object of badges to show/hide with custom content
 * @prop {boolean} hideRating - to toggle if rating is hidden
 * @prop {float} scale - image transform scale
 * @prop {float} hoverScale - image transform scale on hover
 */ function ProductCard(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var price = (0,hooks_products_useProductCardPrice__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((ref = props.product) === null || ref === void 0 ? void 0 : ref.price_range);
    var image = (0,utils_getProductImage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        mainImage: props.product.image,
        gallery: props.product.media_gallery
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ProductCardBox */ .Ps, _objectSpread({}, props, {
        hoverScale: props.hoverScale,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/toode/[toode]",
                as: "/toode/".concat(props.product.url_key),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    children: [
                        !props.hideRating && ((ref1 = props.product) === null || ref1 === void 0 ? void 0 : ref1.rating_summary) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Ratings_StarRating__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            rating: (ref2 = props.product) === null || ref2 === void 0 ? void 0 : ref2.rating_summary,
                            flexDirection: "column",
                            position: "absolute",
                            right: props.scale ? "0.35rem" : "0.6rem",
                            top: props.scale ? "0.25rem" : "0.5rem"
                        }) : null,
                        (price === null || price === void 0 ? void 0 : (ref3 = price.discount) === null || ref3 === void 0 ? void 0 : ref3.value) && ((ref4 = props.badges) === null || ref4 === void 0 ? void 0 : ref4.discount) || ((ref5 = props.badges) === null || ref5 === void 0 ? void 0 : ref5.discount.text) === "Lemmik" || ((ref6 = props.badges) === null || ref6 === void 0 ? void 0 : ref6.discount.text) === "Favourite" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            id: "discount_badge",
                            children: props.badges.discount.text || "Soodus"
                        }) : null,
                        (price === null || price === void 0 ? void 0 : (ref7 = price.discount) === null || ref7 === void 0 ? void 0 : ref7.percentNumber) > 0 && !((ref8 = props.badges) === null || ref8 === void 0 ? void 0 : ref8.discount) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DiscountPercentBadge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            percent: "-" + Math.round(Number(price === null || price === void 0 ? void 0 : (ref9 = price.discount) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.percent) === null || ref10 === void 0 ? void 0 : ref10.replace("-", "").replace(" ", "").replace("kuni", "").replace("%", ""))) + "%"
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            src: image === null || image === void 0 ? void 0 : image.url,
                            alt: image === null || image === void 0 ? void 0 : image.label,
                            width: props.imageSize.width,
                            height: props.imageSize.height,
                            objectFit: "contain"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ProductTitle */ .tc, {
                            scale: props.scale,
                            children: (ref11 = props.product) === null || ref11 === void 0 ? void 0 : ref11.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ProductPrice */ .jF, {
                            scale: props.scale,
                            children: [
                                (price === null || price === void 0 ? void 0 : (ref12 = price.discount) === null || ref12 === void 0 ? void 0 : ref12.value) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: price === null || price === void 0 ? void 0 : (ref13 = price.discount) === null || ref13 === void 0 ? void 0 : ref13.value
                                }) : null,
                                price === null || price === void 0 ? void 0 : price.value
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ButtonsContainer */ .YD, {
                spaceX: "1rem",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Button_AddToCart__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        product: props.product
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 2298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _SkeletonElement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7810);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4337);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0.2rem 0.4rem 0.5rem;\n  border-radius: 12px;\n  border: 0.7px solid #d8d9e5;\n  background-color: white;\n  font-weight: 500;\n  margin-top: 2rem;\n  margin-right: 0.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var MobileSkeletonProductCard = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MobileProductCardBox, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                type: "mobileskeletonimage"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SkeletonInfo, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "mobileskeletontitle"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "mobileskeletontitle"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "mobileskeletontext"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "mobileskeletontext"
                    })
                ]
            })
        ]
    });
};
var MobileProductCardBox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].divBox */ .ZPm.divBox(_templateObject());
var SkeletonInfo = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZPm.div(_templateObject1());
/* harmony default export */ __webpack_exports__["Z"] = (MobileSkeletonProductCard);


/***/ }),

/***/ 7810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8609);
/* harmony import */ var _Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1__);


var SkeletonElement = function(param) {
    var type = param.type;
    // const classes = `skeleton ${type}`;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1___default())[type]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonElement);


/***/ }),

/***/ 3327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _SkeletonElement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7810);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4337);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  max-width: 270px;\n  padding: 0 1.25rem;\n  margin-right: 0.5rem;\n  border: 0.7px solid #d8d9e5;\n  border-radius: 12px;\n  background-color: white;\n  font-weight: 500;\n  height: 369.88px;\n  padding: '1rem 1rem 2rem';\n\n  @media (max-width: lg_tablet) {\n    border: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  padding-bottom: 15%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SkeletonProductCard = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SkeletonProductBox, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                type: "skeletonproductimage"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SkeletonInfo, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "skeletontitle"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "skeletontext"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "skeletontext"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonProductCard);
var SkeletonProductBox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].divBox */ .ZPm.divBox(_templateObject());
var SkeletonInfo = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZPm.div(_templateObject1());


/***/ }),

/***/ 4751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useScrollRestoration; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


function useScrollRestoration(param) {
    var data = param.data;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var saveScrollPos = function(url) {
        var scrollPos = {
            x: window.scrollX,
            y: window.scrollY
        };
        sessionStorage.setItem(url, JSON.stringify(scrollPos));
    };
    var restoreScrollPos = function(url) {
        var scrollPos = JSON.parse(sessionStorage.getItem(url));
        if (scrollPos) {
            if (!sessionStorage.getItem("pagination_change")) {
                setTimeout(function() {
                    window.scrollTo({
                        top: scrollPos.y,
                        behavior: "instant"
                    });
                });
            } else {
                sessionStorage.removeItem("pagination_change");
            }
        }
        if (sessionStorage.getItem("pagination_change")) {
            sessionStorage.removeItem("pagination_change");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ("scrollRestoration" in window.history && data) {
            var shouldScrollRestore = false;
            window.history.scrollRestoration = "manual";
            restoreScrollPos(router.asPath);
            var onBeforeUnload = function(event) {
                saveScrollPos(router.asPath);
                delete event["returnValue"];
            };
            var onRouteChangeStart = function() {
                saveScrollPos(router.asPath);
            };
            var onRouteChangeComplete = function(url) {
                if (shouldScrollRestore) {
                    shouldScrollRestore = false;
                    restoreScrollPos(url);
                }
            };
            window.addEventListener("beforeunload", onBeforeUnload);
            router.events.on("routeChangeStart", onRouteChangeStart);
            router.events.on("routeChangeComplete", onRouteChangeComplete);
            router.beforePopState(function() {
                shouldScrollRestore = true;
                return true;
            });
            return function() {
                window.removeEventListener("beforeunload", onBeforeUnload);
                router.events.off("routeChangeStart", onRouteChangeStart);
                router.events.off("routeChangeComplete", onRouteChangeComplete);
                router.beforePopState(function() {
                    return true;
                });
            };
        }
    }, [
        data
    ]);
};


/***/ }),

/***/ 8510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePagination; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_query_params__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4873);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1131);
/* harmony import */ var global_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(561);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





function usePagination() {
    var ref = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_3__/* .useAtom */ .KO)(global_store__WEBPACK_IMPORTED_MODULE_1__/* .currentPageAtom */ .ef), 2), currentPage = ref[0], setCurrentPage = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = _slicedToArray((0,next_query_params__WEBPACK_IMPORTED_MODULE_4__/* .useQueryParam */ .Wd)("p", (0,next_query_params__WEBPACK_IMPORTED_MODULE_4__/* .withDefault */ .Wc)(next_query_params__WEBPACK_IMPORTED_MODULE_4__/* .NumberParam */ .yz, currentPage)), 2), pageQuery = ref1[0], setPageQuery = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Sync query param with the current page state
        if (currentPage === 1) {
            // Remove 'p' from query if on the first page
            var _query = router.query, p = _query.p, rest = _objectWithoutProperties(_query, [
                "p"
            ]);
            router.replace({
                pathname: router.pathname,
                query: rest
            }, undefined, {
                shallow: true
            });
        } else {
            // Update 'p' query param
            setPageQuery(currentPage);
        }
    }, [
        currentPage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Sync state with the query param
        setCurrentPage(pageQuery);
    }, [
        pageQuery
    ]);
    return pageQuery;
};


/***/ }),

/***/ 8812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductPages; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1131);
/* harmony import */ var global_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(561);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




function useProductPages(getProducts, data) {
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), products = ref4[0], setProducts = ref4[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), pages = ref1[0], setPages = ref1[1];
    var ref2 = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_2__/* .useAtom */ .KO)(global_store__WEBPACK_IMPORTED_MODULE_1__/* .currentPageAtom */ .ef), 2), currentPage = ref2[0], setCurrentPage = ref2[1];
    // Execute products query upon page change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return getProducts();
    }, [
        currentPage
    ]);
    // Set products & pages
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.products) {
            var ref, ref3;
            setProducts(data === null || data === void 0 ? void 0 : data.products.items);
            var pageAmount = data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : (ref3 = ref.page_info) === null || ref3 === void 0 ? void 0 : ref3.total_pages;
            if (pages !== pageAmount) {
                setPages(pageAmount);
            }
        }
    }, [
        data === null || data === void 0 ? void 0 : data.products
    ]);
    return {
        products: products,
        pages: pages
    };
};


/***/ }),

/***/ 8609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeletonproductimage":"Skeleton_skeletonproductimage__iedNz","skeletontitle":"Skeleton_skeletontitle__mmij2","skeletontext":"Skeleton_skeletontext__BMljH","mobileskeletonimage":"Skeleton_mobileskeletonimage__LE2pX","mobileskeletontitle":"Skeleton_mobileskeletontitle__uG6xV","mobileskeletontext":"Skeleton_mobileskeletontext__DK8qh"};

/***/ })

}]);